import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "accordion__footer" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("button", { class: "accordion__send profile__run" }, " Завершить ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "accordion__send profile__run",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.rotateWords && _ctx.rotateWords(...args)))
    }, " Перевернуть гармошку "),
    _createVNode(_component_router_link, {
      to: { name: 'Account', params: { id: _ctx.userID } }
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}